import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { Api } from '../../libs/api'

const titH3 = {
    height: '78px'
}

class AsideMedium extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            news: [],
            review: [],
            medium_list: [],
            loadData: false,
        }
    }

    componentWillMount() {
        if (this.props.selectCategory) {
            this.setList(this.props.selectCategory)
        }
    }

    componentWillReceiveProps(nextProps) {
        // category 변경시
        if (nextProps.selectCategory !== this.props.selectCategory) {
            this.setList(nextProps.selectCategory)
        }
    }

    setList(cate_id) {
        this.selectCategory = cate_id
        Api.getAsideMedium(cate_id).then(response => {
            if (response.data.code === 200) {
                let news = response.data.result.news
                let review = response.data.result.review
                let mediumList = response.data.result.medium
                let curation = response.data.result.curation
                let curationAd = response.data.result.curationAd

                let curationList = []
                curation.map((v, _k) => {
                    if (v.lnk_youtube !== undefined && v.lnk_youtube !== null && v.lnk_youtube !== "") {
                        curationList.push(v)
                    }
                    return false
                })
                this.setState({
                    news,
                    review,
                    mediumList,
                    curation: curationList,
                    curationAd,
                    loadData: true,
                })
            }
        })
    }

    render() {
        if (this.state.loadData === false) return false
        let host = ''
        if (this.props.domain === 'minishop') {
            host = process.env.REACT_APP_PC_URL
        }

        return (
            <div className="aside-medium">
                <h2 className="tit-h2">
                    <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/tit_medium_aside.png`} alt="미디엄" />
                </h2>

                <article className="aside-medium_box">
                    <h3 className="tit-h3" style={titH3}>
                        {
                            // eslint-disable-next-line
                        }<a>
                            미디엄 가이드
                            <br />
                            <span>구매의 기준을 바꾸다!</span>
                        </a>
                    </h3>
                    {this.state.mediumList.map((v, _k) => {
                        if (v.cate_id.toString() !== this.props.selectCategory.toString()) return true

                        let href = host + '/list/' + v.cate_id + '/mguide'
                        let link = <a href={href}>{v.subject}</a>
                        let newImg = v.new_check
                            ? <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/ico_new_red.gif`} alt='새글' style={{verticalAlign: 'middle'}}/>
                            : ''

                        if (this.props.domain === 'minishop') {
                            link = <a href={href} target="_blank" rel="noopener noreferrer">{newImg}{v.subject}</a>
                        } else {
                            link = <Link to={href}>{newImg}{v.subject}</Link>
                        }

                        return (
                            <div className="aside-medium_box_cate" key={v.cate_id}>
                                <p>{link}</p>
                            </div>
                        )
                    })}
                    {this.state.curationAd.length > 0 && (
                        <div className="MdmCuration">
                            <strong className="BdTxt">큐레이션</strong>
                            {this.state.curationAd.map((v, _k) => {
                                let host = this.props.domain === 'shopping' ? '' : process.env.REACT_APP_SHOPPING_URL
                                let href = `${host}/list/${v.cat_id}/curation/${v.num_curation}`

                                return (
                                    <div className="list" key={_k}>
                                        {this.props.domain !== 'shopping'
                                            ? <a href={href} target="_blank" rel="noopener noreferrer"><img src={`https://i.ytimg.com/vi/${v.lnk_youtube}/mqdefault.jpg`} className="youtube_img" alt={v.nm_curation}/></a>
                                            : <Link to={href}><img src={`https://i.ytimg.com/vi/${v.lnk_youtube}/mqdefault.jpg`} className="youtube_img" alt={v.nm_curation}/></Link>
                                        }
                                        <p>
                                            {this.props.domain !== 'shopping'
                                                ? <a href={href} target="_blank" rel="noopener noreferrer">{v.nm_curation}</a>
                                                : <Link to={href}>{v.nm_curation}</Link>
                                            }
                                        </p>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    <div className="MdmNews">
                        <strong className="BdTxt">뉴스</strong>
                        {this.state.news.length > 0 ? (
                            this.state.news.map((v, _k) => {
                                let href = host + '/list/' + v.cate_id + '/mreview/' + v.idx_threads
                                let link = <a href={href}>{v.subject}</a>
                                let newImg = v.new_check
                                    ? <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/ico_new_red.gif`} alt='새글' style={{verticalAlign: 'middle'}} />
                                    : ''
                                if (this.props.domain === 'minishop') {
                                    link = <a href={href} target="_blank" rel="noopener noreferrer">{newImg}{v.subject}</a>
                                } else {
                                    link = <Link to={href}>{newImg}{v.subject}</Link>
                                }

                                return <p key={v.idx_threads}>{link}</p>
                            })
                        ) : (
                            <p>해당 뉴스를 준비중입니다.</p>
                        )}
                    </div>
                    <div className="MdmNews">
                        <strong className="BdTxt">리뷰</strong>
                        {this.state.review.length > 0 ? (
                            this.state.review.map((v, _) => {
                                let href = host + '/list/' + v.cate_id + '/mreview/' + v.idx_threads
                                let link = <a href={href}>{v.subject}</a>
                                let newImg = v.new_check
                                    ? <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/ico_new_red.gif`} alt='새글' style={{verticalAlign: 'middle'}} />
                                    : ''
                                if (this.props.domain === 'minishop') {
                                    link = <a href={href} target="_blank" rel="noopener noreferrer">{newImg}{v.subject}</a>
                                } else {
                                    link = <Link to={href}>{newImg}{v.subject}</Link>
                                }

                                return <p key={v.idx_threads}>{link}</p>
                            })
                        ) : (
                            <p>해당 리뷰를 준비중입니다.</p>
                        )}
                    </div>
                    {/* {this.state.curation.length > 0 && (
                        <div className="MdmCuration">
                            <strong className="BdTxt">큐레이션</strong>
                            {this.state.curation.map((v, _k) => {
                                let href= `${host}/list/${v.cat_id}/srch/curation/${v.num_curation}`
                                return (
                                    <div className="list" key={_k}>
                                        <a href={href}><img src={`https://i.ytimg.com/vi/${v.lnk_youtube}/mqdefault.jpg`} className="youtube_img" alt={v.nm_curation}/></a>
                                        <p><a href={href}>{v.nm_curation}</a></p>
                                    </div>
                                )
                            })}
                        </div>
                    )} */}
                </article>
            </div>
        )
    }
}

let stateData = state => {
    return {
        selectCategory: state.initial.selectCategory,
        domain: state.initial.domain,
    }
}

export default connect(stateData)(AsideMedium)



// WEBPACK FOOTER //
// ./src/estimate_list/components/medium/asideMedium.js